import {
  Autocomplete,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";

import { useTranslation } from "react-i18next";
import { CustomTextField } from "../../Components/CustomTextField";
import { RiskForm } from "./RiskForm/RiskForm";
import { materials } from "./materials_data";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { ImageGalleryRow } from "../ImagesForm/ImagesForm";
import { uploadAttachment } from "../../../../../../../api/ApiAttachments";
import { ImageGalleryRow } from "../../../../../../CustomComponents/ImageGalleryRow/ImageGalleryRow";
export const AsbestosForm = ({ formValues, handleChange }) => {
  const { t } = useTranslation("main");
  const [showMore, setShowMore] = useState(false);
  const isMobile = window.innerWidth < 960;

  const handleUploadImage = (referenced_by_type) => async (selectedFile) => {
    if (!selectedFile) {
      alert("Por favor, selecciona una imagen antes de subirla.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("filename", selectedFile.name);
    formData.append("filepath", `/attachments/${referenced_by_type}`);
    formData.append("filetype", selectedFile.type);
    formData.append("referenced_by_type", referenced_by_type);

    try {
      await uploadAttachment(formValues.uuid, formData);
    } catch (error) {
      console.error("Error subiendo la imagen:", error);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <CustomTextField
        field="is_asbestos"
        value={formValues.is_asbestos}
        options={["MCA", "MPCA", "NOMCA"]}
        onChange={handleChange}
      />
      <CustomTextField
        field="description"
        value={formValues.description}
        onChange={handleChange}
        minRows={3}
      />
      <div
        style={{
          display: "flex",
          gap: "1rem",
          flexDirection: isMobile ? "column" : "",
        }}
      >
        <CustomTextField
          field="inspection_type"
          value={formValues.inspection_type}
          options={["PRELIMINAR", "BASICO", "DETALLADO"]}
          onChange={handleChange}
        />

        <Autocomplete
          value={formValues.element_type || ""}
          onChange={(event, newInputValue, newValue) => {
            handleChange("element_type")(newInputValue);
          }}
          freeSolo
          fullWidth
          options={["CUBIERTA", "PARAMENTO", "BAJANTE"]}
          getOptionLabel={(option) => t(option)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("element_type")}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: formValues.element_type && (
                  <InputAdornment
                    position="end"
                    style={{ marginRight: "10px" }}
                  >
                    <IconButton
                      onClick={() => handleChange("element_type")("")}
                      size="small"
                      style={{
                        width: "0.9rem",
                        height: "0.9rem",
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
          renderGroup={(params) => (
            <li key={params.key}>
              <div
                style={{
                  backgroundColor: "rgb(243, 243, 243)",
                  padding: "8px",
                }}
              >
                {params.group}
              </div>
              <ul style={{ padding: 0, margin: 0 }}>{params.children}</ul>
            </li>
          )}
          popupIcon={<ArrowDropDownIcon />}
        />
      </div>
      <div
        style={{
          display: "flex",
          gap: "1rem",
          flexDirection: isMobile ? "column" : "",
        }}
      >
        <Autocomplete
          value={
            materials
              .flatMap((cat) =>
                cat.options.map((opt) => ({
                  label: opt,
                  category: `${cat.label}`,
                }))
              )
              .find((opt) => opt.label === formValues.material) || null
          } // Aseguramos que el value sea el objeto que coincide con formValues.material
          onChange={(event, newInputValue, newValue) => {
            handleChange("material")(newInputValue.label);
          }}
          freeSolo
          fullWidth
          options={materials.flatMap((cat, index) =>
            cat.options.map((opt) => ({
              label: opt,
              category: `${index + 1} - ${t(cat.label)}`,
            }))
          )}
          groupBy={(option) => option.category}
          getOptionLabel={(option) => {
            return t(option.label);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("material")}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: formValues.material && (
                  <InputAdornment
                    position="end"
                    style={{ marginRight: "10px" }}
                  >
                    <IconButton
                      onClick={() => handleChange("material")("")}
                      size="small"
                      style={{
                        width: "0.9rem",
                        height: "0.9rem",
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
          renderGroup={(params) => (
            <li key={params.key}>
              <div
                style={{
                  backgroundColor: "rgb(243, 243, 243)",
                  padding: "8px",
                }}
              >
                {params.group}
              </div>
              <ul style={{ padding: 0, margin: 0 }}>{params.children}</ul>
            </li>
          )}
          popupIcon={<ArrowDropDownIcon />}
        />
        <CustomTextField
          field="asbestos_type"
          value={formValues.asbestos_type}
          options={["CRISOTILO", "ASBESTOS"]}
          onChange={handleChange}
        />
      </div>

      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={formValues.has_lab_measures}
              onChange={handleChange("has_lab_measures")}
            />
          }
          label={t("has_lab_measures")}
        />
      </FormGroup>

      <div
        style={{
          maxHeight: formValues.has_lab_measures ? "500px" : "0px",
          overflow: "hidden",
          transition: "max-height 0.5s ease-in-out",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <div
          style={{
            margin: "1rem",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <CustomTextField
            field="lab_measure_ref_code"
            value={formValues.lab_measure_ref_code}
            onChange={handleChange}
            sx={{
              marginTop: "8px",
            }}
          />
          <CustomTextField
            field="lab_measure_note"
            value={formValues.lab_measure_note}
            onChange={handleChange}
            minRows={3}
          />
          <ImageGalleryRow
            uuid={formValues.uuid}
            handleUpload={handleUploadImage}
            referenced_by_type={"LAB_MEASURES"}
            canDelete
          />
        </div>
      </div>
      {/* )} */}
      <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
        <Typography
          style={{ cursor: "pointer" }}
          onClick={() => setShowMore((prev) => !prev)}
        >
          {showMore ? `- ${t("less")}` : `+ ${t("more")}`}
        </Typography>
        <Divider style={{ flexGrow: "1" }} />
      </div>
      <div
        style={{
          maxHeight: showMore ? (isMobile ? "5000px" : "2500px") : "0px",
          overflow: "hidden",
          transition: "max-height 0.5s ease-in-out",
          margin: "1rem",
          marginTop: "calc(1rem - 8px)",
        }}
      >
        <div
          style={{
            marginTop: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <CustomTextField
            field="risk_final_value"
            value={formValues.risk_final_value}
            readOnly
          />
          <Stack
            direction="row"
            spacing={1}
            sx={{ alignItems: "center", justifyContent: "center" }}
          >
            <Typography>{t("simple")}</Typography>
            <Switch
              checked={formValues.useRiskForm === "FORM"}
              onChange={(event) =>
                handleChange("useRiskForm")(
                  event.target.checked ? "FORM" : "SIMPLE"
                )
              }
              inputProps={{ "aria-label": "controlled" }}
            />
            <Typography>{t("form")}</Typography>
          </Stack>
          {formValues.useRiskForm === "FORM" ? (
            <>
              <CustomTextField
                field="risk_form_value"
                value={formValues.risk_form_value}
                readOnly
              />
              <RiskForm formValues={formValues} handleChange={handleChange} />
            </>
          ) : (
            <CustomTextField
              field="risk_simplify_type"
              value={formValues.risk_simplify_type}
              options={["Muy Alto", "Alto", "Medio", "Bajo"]}
              onChange={handleChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};
